import {
  useFilterList as useCoreFilterList,
  initialFiltersState,
} from "@b2bportal/core-hotels";
import { toStarRating } from "@b2bportal/core-utilities";
import type { Amenity } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelsAvailability } from "@tenant/hotels";

export const useFilterList = () => {
  const { t } = useI18nContext();
  const coreHook = useCoreFilterList();
  const { amenities: selectedAmenities } = coreHook.context;
  const { context } = useHotelsAvailability();

  const amenitiesList = coreHook.context.filterOptions.amenities;

  const getAmenityLabel = (amenity: Amenity) =>
    amenitiesList.find((amenityOption) => amenityOption.amenity === amenity)
      ?.displayName;

  return {
    handlers: coreHook.handlers,
    context: coreHook.context,
    text: {
      price: {
        title: t("core-hotels.availabilityPage.filters.price.title"),
        description: t(
          "core-hotels.availabilityPage.filters.price.description"
        ),
      },
      starRating: {
        ...coreHook.text,
        title:
          context.starRating.length === initialFiltersState.starRating.length
            ? t("core-hotels.availabilityPage.filters.starRating.title")
            : t(
                "core-hotels.availabilityPage.filters.starRating.filterAppliedTitle.applied",
                {
                  count: toStarRating(context.starRating[0]),
                }
              ) +
              (context.starRating.length > 1
                ? ` +${context.starRating.length - 1}`
                : ""),
      },
      freeCancellation: {
        title: t(
          "core-hotels.availabilityPage.results.hotelCard.features.freeCancellation"
        ),
      },
      amenities: {
        title:
          selectedAmenities.length >= 1
            ? selectedAmenities.length > 1
              ? t(
                  "core-hotels.availabilityPage.filters.amenities.filterAppliedTitle.multipleApplied",
                  {
                    type: getAmenityLabel(selectedAmenities[0]),
                    count: coreHook.context.amenities.length - 1,
                    interpolation: { escapeValue: false },
                  }
                )
              : t(
                  "core-hotels.availabilityPage.filters.amenities.filterAppliedTitle.oneApplied",
                  {
                    type: getAmenityLabel(selectedAmenities[0]),
                    interpolation: { escapeValue: false },
                  }
                )
            : t("core-hotels.availabilityPage.filters.amenities.title"),
      },
      payLater: {
        title: t("core-hotels.availabilityPage.filters.payLater.title"),
        description: t(
          "core-hotels.availabilityPage.filters.payLater.description"
        ),
      },
      resetFilters: t("core-hotels.availabilityPage.filters.resetFilters"),
    },
  };
};
